module.exports = __webpack_public_path__ + "static/media/text-format.e8c1874d.svg";